import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';
import { ISystemInoperability } from 'ApiPackage/SystemInoperabilityModule/interfaces/ISystemInoperability';

export const initialSystemInoperabilityTableColumns: ITableColumn<ISystemInoperability>[] = [
  { id: 'startDate', name: 'Начало периода', sort: TableColumnSortEnum.NONE, isSelected: true },
  { id: 'endDate', name: 'Окончание периода', sort: TableColumnSortEnum.NONE, isSelected: true },
  { id: 'reason', name: 'Причина возникновения', sort: TableColumnSortEnum.NONE, isSelected: true },
];
